exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sbolSequence[data-v-753ab302]{height:200px;background-color:#fff;border-radius:5px 5px 0 0;position:relative;margin:1px 0}.sequence[data-v-753ab302]{word-break:break-word;text-transform:uppercase;line-height:2em;padding:8px;font-family:monospace;font-size:16px}.scrollable[data-v-753ab302]{overflow-y:scroll;height:200px}", ""]);

// exports
